<template>
  <div class="point-editor">
    <AppMapPointPanelHeader :header="header" @close="$emit('close')" />
    <div class="point-editor__content">
      <b-form>
        <slot name="floor"></slot>
        <b-form-group label="Name" :state="!$v.pointTemp.title.$model">
          <b-input type="text" placeholder="Name" v-model="$v.pointTemp.title.$model" />
          <template #invalid-feedback>
            <div v-if="!$v.pointTemp.title.serverErrors">
              {{ getServerFieldErrors('title') }}
            </div>
          </template>
        </b-form-group>
        <b-form-group label="Reference ID" :state="!$v.pointTemp.reference_id.$model">
          <b-input type="text" placeholder="Unique reference ID" v-model="$v.pointTemp.reference_id.$model" />
          <template #invalid-feedback>
            <div v-if="!$v.pointTemp.reference_id.serverErrors">
              {{ getServerFieldErrors('reference_id') }}
            </div>
          </template>
        </b-form-group>
        <b-form-group label="Link" :state="!$v.pointTemp.url.$model">
          <b-input type="text" placeholder="URL" v-model="$v.pointTemp.url.$model" />
          <template #invalid-feedback>
            <div v-if="!$v.pointTemp.url.serverErrors">
              {{ getServerFieldErrors('url') }}
            </div>
          </template>
        </b-form-group>
        <b-form-group label="Note" :state="!$v.pointTemp.description.$model">
          <b-textarea v-model="$v.pointTemp.description.$model" />
          <template #invalid-feedback>
            <div v-if="!$v.pointTemp.description.serverErrors">
              {{ getServerFieldErrors('description') }}
            </div>
          </template>
        </b-form-group>
        <div class="btn-panel">
          <b-btn type="button" v-if="can(PN.PRINTER_DELETE) && !isNew" variant="default" @click="destroy" title="Delete" class="mr-auto">
            <i class="ion ion-md-trash"></i
          ></b-btn>
          <div class="ml-auto"></div>
          <b-btn type="button" variant="primary" @click="save">Save</b-btn>
          <b-btn type="button" variant="default" @click="cancel">Cancel</b-btn>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { isLocalId } from '@/utils/Id'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as PN from '@/utils/PermissionNames'
import { POINT_UPDATE } from '@/store/modules/point'
import AppMapPointPanelHeader from '@/components/shared/AppMapPointPanelHeader.vue'
import { getItemHeader } from '@/components/shared/helpers'
import { convertServerErrors } from '@/utils/Helpers'

export default {
  name: 'PointEditor',
  components: { AppMapPointPanelHeader },
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    point: {
      type: Object
    }
  },
  validations() {
    return {
      pointTemp: {
        title: {
          serverErrors: function() {
            return !this.getServerFieldErrors('title')
          }
        },
        description: {
          serverErrors: function() {
            return !this.getServerFieldErrors('description')
          }
        },
        url: {
          serverErrors: function() {
            return !this.getServerFieldErrors('url')
          }
        },
        reference_id: {
          serverErrors: function() {
            return !this.getServerFieldErrors('reference_id')
          }
        }
      }
    }
  },
  data: () => ({
    PN,
    pointTemp: {
      title: '',
      description: '',
      url: '',
      reference_id: ''
    },
    serverErrors: {}
  }),
  computed: {
    ...mapGetters('point', ['getPoint']),
    ...mapGetters('rbac', ['can']),
    header() {
      return getItemHeader(this.point, 'Point')
    },
    isNew() {
      return isLocalId(this.pointTemp.id)
    }
  },
  methods: {
    ...mapMutations('point', {
      pointUpdate: POINT_UPDATE
    }),
    ...mapActions('point', ['pointSave']),
    /**
     * @param fieldName
     * @returns {string} merged error messages splited by br tag
     */
    getServerFieldErrors(fieldName) {
      if (this.serverErrors && this.serverErrors[fieldName]) {
        return this.serverErrors[fieldName].join('<br>')
      }
      return ''
    },
    save() {
      this.serverErrors = {}
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = Object.assign(this.pointTemp, { floor_id: this.point.floor_id, lat_lon: this.point.lat_lon })

        this.pointSave(payload).then((pointId) => {
            this.$emit('save', { pointId })
          }, (error) => {
            if (error.response && error.response.status === 422) {
              this.serverErrors = convertServerErrors(error.response.data)
            }
          })
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    destroy() {
      this.$appToast.question('A you sure want to delete point?').then(() => {
        this.$emit('destroy')
      })
    }
  },
  watch: {
    id: {
      immediate: true,
      handler(id) {
        this.pointTemp = {
          ...this.getPoint(id),
          id
        }
      }
    }
  }
}
</script>

<style lang="scss">
.point-editor__content {
  padding: 24px;
}

.select-item {
  display: flex;
  justify-items: left;

  .btn {
    margin-left: auto;
  }
}
</style>
